import { chakra, SystemStyleObject, Text } from '@chakra-ui/react'
import React from 'react'

export const REFER_BUTTON_CLASS_NAME = 'refer-call-button'

interface ReferButtonProps {
  buttonText: string
  ariaLabel: string
  onClick: () => void
  buttonStyles?: SystemStyleObject
  textStyles?: SystemStyleObject
}
export const ReferButton = ({
  buttonText,
  ariaLabel,
  onClick,
  buttonStyles,
  textStyles,
}: ReferButtonProps) => {
  return (
    <chakra.button
      type="button"
      className={REFER_BUTTON_CLASS_NAME}
      aria-label={ariaLabel}
      onClick={onClick}
      css={buttonStyles}
    >
      <Text css={textStyles}>{buttonText}</Text>
    </chakra.button>
  )
}
